import axios from '@/jslib/axios'

export const getUnresolvedTicketList = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/unresolved/list',
    params
  })
}

export const getAllTicketList = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/all/list',
    params
  })
}

export const getUnassignedTicketList = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/unassigned/list',
    params
  })
}

export const getSnoozedTicketList = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/snoozed/list',
    params
  })
}


export const createGeneralTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/general/create',
    data
  })
}

export const createEndorsementTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/endorsement/create',
    data
  })
}

export const createCreditTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/credit/create',
    data
  })
}

export const createClaimTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/claim/create',
    data
  })
}

export const createBusinessTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/business/create',
    data
  })
}

export const getCustomerPolicy = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/customer/policy',
    params
  })
}

export const setResolvedTicket = data => {
  return axios({
    method: 'put',
    url: '/admin/ticket/resolved/set',
    data
  })
}

export const getTicketDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/detail',
    params
  })
}

export const getTicketRemark = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/remark/list',
    params
  })
}

export const addTicketRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/remark/add',
    data
  })
}

export const sendSMS = (data,name='ticket') => {
  return axios({
    method: 'post',
    url: `/admin/${name}/sms/send`,
    data
  })
}

export const sendEmail = (data,name='ticket') => {
  return axios({
    method: 'post',
    url: `/admin/${name}/email/send`,
    data
  })
}

export const sendNotification = (data,name='ticket') => {
  return axios({
    method: 'post',
    url: `/admin/${name}/notification/send`,
    data
  })
}

export const sendWhatsApp = (data,name='ticket') => {
  return axios({
    method: 'post',
    url: `/admin/${name}/whats_app/send`,
    data
  })
}

export const setTicketSnooze = data => {
  return axios({
    method: 'put',
    url: '/admin/ticket/snooze/set',
    data
  })
}

export const setTicketUnsnooze = data => {
  return axios({
    method: 'put',
    url: '/admin/ticket/unsnooze/set',
    data
  })
}

export const changeTicketCategory = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/category/change',
    data
  })
}

// business edit
export const editTicketBusiness = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/quote/edit',
    data
  })
}

export const editTicketEndorsement = data => {
  return axios({
    method: 'post',
    url: '/admin/policy/modify/edit',
    data
  })
}

export const editTicketCredit = data => {
  return axios({
    method: 'post',
    url: '/admin/commission/edit',
    data
  })
}

export const editTicketClaim = data => {
  return axios({
    method: 'post',
    url: '/admin/claim/edit',
    data
  })
}

// 分配 cs
export const setTicketCs = data => {
  return axios({
    method: 'put',
    url: '/admin/ticket/cs/set',
    data
  })
}

export const chooseTicketCustomer = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/choose/customer',
    data
  })
}

export const chooseTicketQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/choose/quote',
    data
  })
}

export const chooseTicketPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/choose/policy',
    data
  })
}

export const reopenTicket = data => {
  return axios({
    method: 'put',
    url: '/admin/ticket/reopen/set',
    data
  })
}


export const getCancelForm = params => {
  return axios({
    method: 'get',
    url: '/admin/policy/cancel/form',
    params,
    responseType: 'blob',
  })
}

export const getClaimForm = params => {
  return axios({
    method: 'get',
    url: '/admin/claim/form',
    params
  })
}

// payment success 頁獲取 ticket list
export const getTicketRelationList = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/relation/list',
    params
  })
}

export const setTicketRelation = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/relation/set',
    data
  })
}

export const addManualQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/quote/add',
    data
  })
}

export const editManualQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/quote/data/edit',
    data
  })
}

export const addManualPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/policy/add',
    data
  })
}

export const editManualPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/policy/data/edit',
    data
  })
}

// 取消 ticket list 小藍點
export const setTicketClientUpdated = data => {
  return axios({
    method: 'put',
    url: '/admin/ticket/client_updated/set',
    data
  })
}

export const addRelatedTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/related/add',
    data
  })
}

export const getManualPremiumResult = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/premium/result',
    data
  })
}

export const paymentForSme = data => {
  return axios({
    method: 'post',
    url: '/admin/payment/for/sme',
    data
  })
}

export const generateManualPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/policy/generate',
    data
  })
}

export const manualFileSave = data => {
  return axios({
    method: 'post',
    url: '/admin/manual/file/save',
    data
  })
}

export const manualFileDel = data => {
  return axios({
    method: 'delete',
    url: '/admin/manual/file/delete',
    data
  })
}
export const ticketInternalFileSave = data => {
  return axios({
    method: 'post',
    url: '/admin/ticket/internal/file/save',
    data
  })
}
export const ticketInternalFileDel = data => {
  return axios({
    method: 'delete',
    url: '/admin/ticket/internal/file/del',
    data
  })
}

export const getManualEmailContent = params => {
  return axios({
    methods: 'get',
    url: '/admin/manual/email/content',
    params
  })
}

export const getTransferContent = params => {
  return axios({
    methods: 'get',
    url: '/admin/ticket/credit/send/content',
    params
  })
}
